import React from "react";
import { Box, Text, Flex } from "@chakra-ui/react";

import CartItem from "./cartItem";
import IsDoctor from "../permission/isDoctor";

export default function Index({ cart }) {
  const subTotal = cart.reduce(
    (a, b) => a + b.quantity * parseFloat(b.price),
    0
  );
  const subTotalDoctorPrice = cart.reduce(
    (a, b) => a + b.quantity * parseFloat(b.doctorPrice),
    0
  );

  return (
    <Box
      flexDirection="column"
      d={{ base: "none", md: "flex" }}
      width={{ base: "100%", xl: "75%" }}
    >
      <Flex
        p="20px"
        bg="light"
        width="100%"
        height="50px"
        borderWidth="1px"
        alignItems="center"
        borderColor="cartItemBorder"
      >
        <Box width="45%">
          <Text variant="cartBold">Product</Text>
        </Box>
        <Box width="12%">
          <Text variant="cartBold">Price</Text>
        </Box>
        <Box width="23%">
          <Text variant="cartBold">Quantity</Text>
        </Box>
        <Box width="20%">
          <Text variant="cartBold">Subtotal</Text>
        </Box>
      </Flex>

      <Box m={0} width="100%" overflowY="auto" maxHeight="500px">
        {cart.map((product) => (
          <CartItem key={product.id} product={product} />
        ))}
      </Box>
      <Flex
        p="20px"
        bg="light"
        width="100%"
        height="50px"
        borderWidth="1px"
        alignItems="center"
        borderColor="cartItemBorder"
      >
        <Box width="60%">
          <Text variant="cartBold">
            Total {cart.length} {cart.length === 1 ? "Item" : "Items"}
          </Text>
        </Box>
        <Box width="20%">
          <Text variant="cartBold">Subtotal</Text>
        </Box>
        <Box width="20%">
          <Text variant="cartBold">
            ₹
            {IsDoctor()
              ? parseFloat(subTotalDoctorPrice).toFixed(2)
              : parseFloat(subTotal).toFixed(2)}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}
